export default {
    common: {
        email: '이메일',
        LoginBtn: '로그인',
        SignUpBtn: '회원가입',
        SubmitBtn: '제출',
        ExitBtn: '출구',
        LogoutBtn: '로그아웃'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: '이메일로 보내드린 인증코드를 확인해주세요.',
        VerificationCode: '인증 코드'
    },
    header: {
        OrderHistory: '주문 내역',
        MYACCOUNT: '내 계정',
        WelcomeBack: '환영합니다'
    },
    detail: {
        TotalOrders: '주문 수',
        TotalProducts: '상품 수',
        WonderlandPoints: 'Wonderland 포인트',
        APMCredits: 'APM 크레딧',
        ExpireOn: '만료일',
        NoAPMCredits: 'APM 크레딧 없음',
        CreditsLoading: '크레딧 로딩중',
        Orders: '주문',
        Online: '온라인',
        Boutique: '부티크',
        Total: '총합',
        Delivered: '배송 완료',
        NoData: '데이터 없음',
        Status: '상태',
        item: '아이템',
        items: '아이템'
    },
    panel: {},
    entry: {
        Client: '고객',
        OrderDate: '주문 날짜',
        DeliverDate: '배송 날짜',
        Description: '설명',
        Total: '총합'
    },
    board: {
        Order: '주문',
        Date: '날짜',
        Total: '총합'
    },
    order: {
        OrderID: '주문 ID',
        PurchasePlace: '위치',
        PurchaseDate: '구매일',
        TotalPrice: '총 가격',
    },
    product: {
        Name: '이름',
        SKU: '재고 관리 코드(SKU)',
        Size: '사이즈',
        Quantity: '수량',
        Price: '가격',
        WarrantyUntil: '보증 기간 만료일',
    },
    ordersLayout: {
            pageTitleOrders: "주문",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "홈",
            navProfile: "프로필",
            navOrders: "주문",
            navWonderland: "Wonderland",
            navWishlist: "위시리스트",
            navContactUs: "문의하기",
            navExchangeReturn: "교환 및 반품",
            footerExchangePolicy: "교환 및 반품 정책",
            footerShipping: "배송",
            footerPrivacy: "개인정보 처리방침",
            footerTerms: "이용약관",
            footerRegion: "프랑스",
            menuTrackOrder: "배송 조회",
            menuViewDetails: "상세 보기",
            back: "뒤로",
            orderNumberHeading: "주문 번호 {{id}}",
            itemsCount_one: "{{count}}개",
            itemsCount_other: "{{count}}개",
            emptyOrders: "주문이 없습니다",
            invoiceSoon: "준비 중",
            storeAddressPending: "주소 추후 제공",
            skuPrefix: "SKU",
            statusLabel: "상태",
            productNameFallback: "상품",
            tabOnline: "온라인",
            tabOffline: "오프라인",
            learnMore: "자세히 보기",
            redeemInStore: "매장에서 사용",
            dateLabel: "날짜",
            itemSingular: "상품",
            statusConfirmed: "확인됨",
            purchaseDateLabel: "구매일:",
            monthJan: "1월",
            monthFeb: "2월",
            monthMar: "3월",
            monthApr: "4월",
            monthMay: "5월",
            monthJun: "6월",
            monthJul: "7월",
            monthAug: "8월",
            monthSep: "9월",
            monthOct: "10월",
            monthNov: "11월",
            monthDec: "12월",
            storeLabel: "매장",
            downloadInvoice: "청구서 다운로드",
            warrantyExpires: "보증 만료일",
            sizeLabel: "사이즈",
            subtotalLabel: "소계",
            totalLabel: "총계",
        },
}


// WEBPACK FOOTER //
// ./src/locales/ko/index.js